import clsx from 'clsx';
import FormEdit from 'core/modules/compositions/FormEdit';
import PropTypes from 'prop-types';
import React, { useEffect, useReducer, useState } from 'react';
import { withTranslation } from 'react-i18next';
import Loader from 'react-loader-spinner';
import { Dialog, DialogConfirm, Icon } from 'ui';
import CommentsListAndCreate from '../../compositions/CommentsListAndCreate';

function FeedBackUser({
  comments = [],
  commentsLength = 0,
  commentsRead,
  currentUser,
  placeholder = null,
  disabled,
  guid,
  inputLabel,
  loading,
  onDeleteComment,
  onDeleteCommentDialog,
  onEditComment,
  onEditCommentDialog,
  onMarkAsRead,
  onPublishComment,
  onShowComments = () => {},
  openProp,
  right,
  showFeedbackOption,
  onFeedback,
  feedbackQuestionType,
  t,
}) {
  const [showComments, setShowComments] = useState(openProp);
  const [popupsState, setPopupsState] = useReducer((state, newState) => ({ ...state, ...newState }), {
    openPopupEdit: false,
    toEdit: {},
    parentGuid: null,
    openPopupDelete: false,
    toDelete: null,
  });

  useEffect(() => {
    if (openProp !== undefined) {
      setShowComments(openProp);

      if (openProp === true) {
        onShowComments(guid);
      }
    }
  }, [openProp]);

  useEffect(() => {
    if (showComments === true) {
      onShowComments(guid);
    }
  }, [showComments]);

  function onClickComment() {
    if (!commentsRead) {
      onShowComments(guid);
    }
    setShowComments(!showComments);
  }

  function renderIcon(id, type, text, onClick) {
    return (
      <div className="post-card__meta-info-icon" onClick={onClick}>
        {<Icon name={type} color={showComments || (commentsLength > 0 && !showComments) ? 'primary' : 'default'} />}
        <span className="post-card__meta-info-icon-text">{text} </span>
      </div>
    );
  }

  function confirmEdit(_guid, _test) {
    onEditCommentDialog(_guid, _test);
    onClosePopup();
  }

  function onEditCommentOpenDialog(guid, value, parentGuid) {
    setPopupsState({ openPopupEdit: true, toEdit: { guid, value }, parentGuid });
  }

  function onClosePopup() {
    setPopupsState({ openPopupEdit: false, toEdit: {}, parentGuid: null });
  }

  function onDeleteCommentOpenDialog(guid) {
    setPopupsState({ openPopupDelete: true, toDelete: guid });
  }

  function onClosePopupDelete() {
    setPopupsState({ openPopupDelete: false, toDelete: null });
  }

  function onSuccessDelete() {
    onDeleteCommentDialog(popupsState.toDelete);
    onClosePopupDelete();
  }

  return (
    <>
      <div className="post-card__meta-info" id={guid}>
        <div className="post-card__meta-info-icons">
          {renderIcon('comment', commentsLength > 0 && !showComments ? 'comment-fill' : 'comment', commentsLength || 0, onClickComment)}
        </div>
        {right}
      </div>

      <div className={clsx('post-card__comments', { 'post-card__comments--show': showComments })}>
        {showComments && (
          <>
            {!loading && (
              <CommentsListAndCreate
                onEdit={onEditCommentDialog ? onEditCommentOpenDialog : onEditComment}
                onDelete={onDeleteCommentDialog ? onDeleteCommentOpenDialog : onDeleteComment}
                currentUser={currentUser}
                comments={comments}
                onPublishComment={onPublishComment}
                parentGuid={guid}
                placeholder={placeholder || t('my-courses:commentPlaceholder')}
                inputLabel={inputLabel}
                disabled={disabled}
                onMarkAsRead={onMarkAsRead}
                showFeedbackOption={showFeedbackOption}
                onFeedback={onFeedback}
                feedbackQuestionType={feedbackQuestionType}
              />
            )}
            {loading && (
              <div className="post-card__loader">
                <Loader type="TailSpin" color="#efdb6d" height={50} width={50} />
              </div>
            )}
          </>
        )}
      </div>

      <Dialog
        className={'dialog-upload popup-manager-small'}
        onClose={onClosePopup}
        isOpen={popupsState.openPopupEdit}
        title={t('my-courses:editMessage')}
      >
        <FormEdit //
          comment={popupsState.toEdit.value}
          commentGuid={popupsState.toEdit.guid}
          isComment={guid}
          onClose={onClosePopup}
          onEdit={confirmEdit}
        />
      </Dialog>

      <DialogConfirm
        isOpen={popupsState.openPopupDelete}
        onClose={onClosePopupDelete}
        onSuccess={onSuccessDelete}
        text={t('my-courses:Are you sure you want to delete this comment?')}
        title={t('common:Delete x?', { name: '' })}
      />
    </>
  );
}

FeedBackUser.propTypes = {
  comments: PropTypes.array,
  commentsLength: PropTypes.number,
  commentsRead: PropTypes.bool,
  currentUser: PropTypes.object,
  disabled: PropTypes.bool,
  guid: PropTypes.string,
  inputLabel: PropTypes.string,
  loading: PropTypes.bool,
  onDeleteComment: PropTypes.func,
  onDeleteCommentDialog: PropTypes.func,
  onEditComment: PropTypes.func, // Optional, envia los datos a editar.
  onEditCommentDialog: PropTypes.func, // Optional, levanta el dialogo de edición.
  onMarkAsRead: PropTypes.func,
  onPublishComment: PropTypes.func,
  onShowComments: PropTypes.func,
  openProp: PropTypes.bool,
  right: PropTypes.node,
  showComments: PropTypes.bool,
  t: PropTypes.func,
  placeholder: PropTypes.string,
  showFeedbackOption: PropTypes.bool,
  onFeedback: PropTypes.func,
  feedbackQuestionType: PropTypes.string,
};

export default withTranslation(['my-courses'])(FeedBackUser);
